import React from 'react';

const AddVehicleContentWrapper = ({ children }) => {
  return <div className="add-vehicle-content-wrapper">{children}</div>;
};

export default AddVehicleContentWrapper;
